export default "__VITE_ASSET__B2BMIB27__"